import { useEffect, useState } from 'react';

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export const scrollToRef = (ref: any) => {
  window.scrollTo(
    0,
    ref.current.offsetTop + (window.pageYOffset + ref.current.getBoundingClientRect().top)
  );
};

export const containerScrollTo = (ref: any, container: Element) => {
  container.scrollTo(0, ref.current.offsetTop);
};

// trigger a resize event
export const triggerWindowResize = () => {
  window.dispatchEvent(new Event('resize'));
};